const data: any = {
  func: { mainTitle: "京东快递", subTitle: "青龙、ECLP系统对接" },
  style: {
    backImageUrl:
      "//img10.360buyimg.com/imagetools/s2880x520_jfs/t1/148559/22/8401/179151/5f5f03efE30659ab8/f51eeee05209ec1c.jpg!q80",
    backColor: "#dddddd",
    backIcon:
      "//img12.360buyimg.com/imagetools/s18x24_jfs/t1/136497/17/9683/1216/5f5f0b37E19d29eb2/cebeceacf2f9e0bc.png!q80",
    isShowIcon: "show",
  },
  data: {},
  _clstag_: "jdzeus_express_zeus_banner",
};
export default data;
